import { useCallback, useState } from "react";
import { User } from "../../types";
import { UserService } from "./user.service";

export function useUser() {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<User>();
  const [dataArray, setDataArray] = useState<User[]>();

  const getUser = useCallback(async (data: string) => {
    setLoading(true);
    const res = await UserService.getUser(data);
    setData(res);
    setLoading(false);
  }, []);

  const getUsers = useCallback(async () => {
    setLoading(true);
    const res = await UserService.getUsers();
    setDataArray(res);
    setLoading(false);
  }, []);

  return {
    getUser,
    getUsers,
    loading,
    data,
    dataArray,
  };
}
